import { CHEST_MIN_CORRECT } from "./chestAnimation";
import { GAME_LEVELS } from "./gameLevels";
import { GEM_FILES, PRECIOUS_GEM_IDS } from "./gems";

/** Ordre du pool de tirage coffre (identique au serveur). */
export const CHEST_GEM_IDS = GEM_FILES.map((filename) => filename.replace(/\.[^.]+$/, ""));

export const CHEST_LEVEL_MAX_RANK = {
  1: 21,
  2: 23,
  3: 24,
  4: 26,
  5: 27,
  6: 28,
};

export function getMinChestLevelForGem(gemId) {
  const index = CHEST_GEM_IDS.indexOf(gemId);
  if (index < 0) return null;

  const rankNeeded = index + 1;
  for (let level = 1; level <= 6; level += 1) {
    if (CHEST_LEVEL_MAX_RANK[level] >= rankNeeded) return level;
  }
  return 6;
}

export function getChestLevelLabel(levelId) {
  return GAME_LEVELS.find((level) => level.id === levelId)?.name ?? `Niveau ${levelId}`;
}

export function getPreciousGemObtainTooltip(gemId) {
  if (!PRECIOUS_GEM_IDS.has(gemId)) return null;

  const minLevel = getMinChestLevelForGem(gemId);
  if (!minLevel) return null;

  const levelName = getChestLevelLabel(minLevel);
  return `Coffre du niveau ${minLevel} (${levelName}) ou supérieur · à partir de ${CHEST_MIN_CORRECT} bonnes réponses sur 15.`;
}
